import React from "react";
import { ProjectCard } from "./ProjectCard";
import { Project } from "../types";
import {
  groupProjectsByCategories,
  sortCategoriesByProjectCount,
} from "../utils/projectGrouping";
import { getCategoryIcon } from "../utils/categoryIcons";

interface ProjectsRendererProps {
  projects: Project[];
  activeFilter: string;
  currentView: "grid" | "list";
}

export const ProjectsRenderer: React.FC<ProjectsRendererProps> = ({
  projects,
  activeFilter,
  currentView,
}) => {
  if (projects.length === 0) {
    return (
      <div className="no-results">
        <h3>No projects found</h3>
        <p>Try adjusting your search or filter criteria</p>
      </div>
    );
  }

  if (activeFilter === "all") {
    return (
      <CategorizedProjectsView projects={projects} currentView={currentView} />
    );
  } else {
    return <ProjectsListView projects={projects} currentView={currentView} />;
  }
};

const CategorizedProjectsView: React.FC<{
  projects: Project[];
  currentView: "grid" | "list";
}> = ({ projects, currentView }) => {
  const categorizedProjects = groupProjectsByCategories(projects);
  const sortedCategories = sortCategoriesByProjectCount(categorizedProjects);

  return (
    <>
      {sortedCategories.map(([category, categoryProjects]) => {
        const IconComponent = getCategoryIcon(category);

        return (
          <div key={category} className="category-section">
            <div className="category-header">
              <div className="category-title-wrapper">
                <IconComponent className="category-icon" />
                <h2 className="category-title">{category}</h2>
              </div>
              <span className="category-count">{categoryProjects.length}</span>
            </div>
            <div className={`projects-grid ${currentView}-view`}>
              {categoryProjects.map((project) => (
                <ProjectCard
                  key={project.name}
                  project={project}
                  view={currentView}
                />
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};

const ProjectsListView: React.FC<{
  projects: Project[];
  currentView: "grid" | "list";
}> = ({ projects, currentView }) => {
  return (
    <div className={`projects-grid ${currentView}-view`}>
      {projects.map((project) => (
        <ProjectCard key={project.name} project={project} view={currentView} />
      ))}
    </div>
  );
};
